"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var ModalX_1 = __importDefault(require("../../components/ModalX"));
var Sports_less_1 = __importDefault(require("./Sports.less"));
var adGuardAPI_1 = require("../../common/adGuardAPI");
var API_BASE = 'https://streamed.pk';
var CACHE_TTL_MS = 60000;
var storageKey = 'streamed_matches_cache_v1';
var sportsStorageKey = 'streamed_sports_cache_v1';
// Helpers
function normalizeUnixTimestamp(ts) {
    if (!ts)
        return null;
    // If seconds (10 digits), convert to ms
    if (ts < 1e12)
        return ts * 1000;
    return ts;
}
// Streamed API functions
function readCache(key) {
    try {
        var raw = localStorage.getItem(key);
        if (!raw)
            return null;
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
function writeCache(key, data) {
    try {
        localStorage.setItem(key, JSON.stringify({ at: Date.now(), data: data }));
    }
    catch (_a) { }
}
function fetchSports() {
    return __awaiter(this, arguments, Promise, function (force) {
        var cached, controller_1, timeoutId, res, json, e_1;
        var _a;
        if (force === void 0) { force = false; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cached = readCache(sportsStorageKey);
                    if (!force && cached && Date.now() - cached.at < CACHE_TTL_MS) {
                        return [2 /*return*/, cached.data];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    controller_1 = new AbortController();
                    timeoutId = setTimeout(function () { return controller_1.abort(); }, 10000);
                    return [4 /*yield*/, fetch("".concat(API_BASE, "/api/sports"), {
                            cache: 'no-store',
                            signal: controller_1.signal
                        })];
                case 2:
                    res = _b.sent();
                    clearTimeout(timeoutId);
                    if (!res.ok) {
                        console.warn("Sports API error: HTTP ".concat(res.status));
                        throw new Error("HTTP ".concat(res.status));
                    }
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = (_b.sent());
                    if (json && Array.isArray(json)) {
                        writeCache(sportsStorageKey, json);
                        return [2 /*return*/, json];
                    }
                    return [2 /*return*/, json];
                case 4:
                    e_1 = _b.sent();
                    console.warn('Failed to fetch sports:', e_1);
                    return [2 /*return*/, (_a = cached === null || cached === void 0 ? void 0 : cached.data) !== null && _a !== void 0 ? _a : null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function fetchMatchesBySport(sportId_1) {
    return __awaiter(this, arguments, Promise, function (sportId, force) {
        var cacheKey, cached, controller_2, timeoutId, res, json, normalized, e_2;
        var _a;
        if (force === void 0) { force = false; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cacheKey = "streamed_matches_".concat(sportId, "_v1");
                    cached = readCache(cacheKey);
                    if (!force && cached && Date.now() - cached.at < CACHE_TTL_MS) {
                        return [2 /*return*/, cached.data];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    controller_2 = new AbortController();
                    timeoutId = setTimeout(function () { return controller_2.abort(); }, 10000);
                    return [4 /*yield*/, fetch("".concat(API_BASE, "/api/matches/").concat(sportId), {
                            cache: 'no-store',
                            signal: controller_2.signal
                        })];
                case 2:
                    res = _b.sent();
                    clearTimeout(timeoutId);
                    if (!res.ok) {
                        console.warn("Matches API error for sport ".concat(sportId, ": HTTP ").concat(res.status));
                        throw new Error("HTTP ".concat(res.status));
                    }
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = (_b.sent());
                    normalized = Array.isArray(json)
                        ? json.map(function (m) { return (__assign(__assign({}, m), { date: normalizeUnixTimestamp(m.date) || 0 })); })
                        : json;
                    if (normalized && Array.isArray(normalized)) {
                        writeCache(cacheKey, normalized);
                        return [2 /*return*/, normalized];
                    }
                    return [2 /*return*/, normalized];
                case 4:
                    e_2 = _b.sent();
                    console.warn("Failed to fetch matches for sport ".concat(sportId, ":"), e_2);
                    return [2 /*return*/, (_a = cached === null || cached === void 0 ? void 0 : cached.data) !== null && _a !== void 0 ? _a : null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function fetchLiveMatches() {
    return __awaiter(this, arguments, Promise, function (force) {
        var cached, controller_3, timeoutId, res, json, normalized, e_3;
        var _a;
        if (force === void 0) { force = false; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cached = readCache(storageKey);
                    if (!force && cached && Date.now() - cached.at < CACHE_TTL_MS) {
                        return [2 /*return*/, cached.data];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    controller_3 = new AbortController();
                    timeoutId = setTimeout(function () { return controller_3.abort(); }, 10000);
                    return [4 /*yield*/, fetch("".concat(API_BASE, "/api/matches/live"), {
                            cache: 'no-store',
                            signal: controller_3.signal
                        })];
                case 2:
                    res = _b.sent();
                    clearTimeout(timeoutId);
                    if (!res.ok) {
                        console.warn("Live matches API error: HTTP ".concat(res.status));
                        throw new Error("HTTP ".concat(res.status));
                    }
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = (_b.sent());
                    normalized = Array.isArray(json)
                        ? json.map(function (m) { return (__assign(__assign({}, m), { date: normalizeUnixTimestamp(m.date) || 0 })); })
                        : json;
                    if (normalized && Array.isArray(normalized)) {
                        writeCache(storageKey, normalized);
                        return [2 /*return*/, normalized];
                    }
                    return [2 /*return*/, normalized];
                case 4:
                    e_3 = _b.sent();
                    console.warn('Failed to fetch live matches:', e_3);
                    return [2 /*return*/, (_a = cached === null || cached === void 0 ? void 0 : cached.data) !== null && _a !== void 0 ? _a : null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function fetchStreams(source, id) {
    return __awaiter(this, void 0, Promise, function () {
        var controller_4, timeoutId, res, json, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    controller_4 = new AbortController();
                    timeoutId = setTimeout(function () { return controller_4.abort(); }, 10000);
                    return [4 /*yield*/, fetch("".concat(API_BASE, "/api/stream/").concat(source, "/").concat(id), {
                            cache: 'no-store',
                            signal: controller_4.signal
                        })];
                case 1:
                    res = _a.sent();
                    clearTimeout(timeoutId);
                    if (!res.ok) {
                        console.warn("Streams API error for ".concat(source, "/").concat(id, ": HTTP ").concat(res.status));
                        throw new Error("HTTP ".concat(res.status));
                    }
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = (_a.sent());
                    return [2 /*return*/, json && Array.isArray(json) ? json : null];
                case 3:
                    e_4 = _a.sent();
                    console.warn("Failed to fetch streams for ".concat(source, "/").concat(id, ":"), e_4);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function formatTime(ts) {
    if (!ts)
        return '';
    try {
        var d = new Date(ts);
        return d.toLocaleString();
    }
    catch (_a) {
        return '';
    }
}
function isLive(now, match) {
    // Live if started within last 2 hours
    var startTime = match.date;
    var currentTime = now;
    return startTime > 0 && currentTime >= startTime && currentTime <= startTime + (2 * 60 * 60 * 1000);
}
function isUpcoming(now, match) {
    return match.date > now;
}
function getTimeRemaining(now, match) {
    var startTime = match.date;
    var currentTime = now;
    if (currentTime < startTime) {
        var remaining = startTime - currentTime;
        var hours = Math.floor(remaining / (1000 * 60 * 60));
        var minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        if (hours > 0)
            return "Starts in ".concat(hours, "h ").concat(minutes, "m");
        if (minutes > 0)
            return "Starts in ".concat(minutes, "m");
        return 'Starting now';
    }
    else if (isLive(currentTime, match)) {
        var endTime = startTime + (2 * 60 * 60 * 1000);
        var remaining = endTime - currentTime;
        var hours = Math.floor(remaining / (1000 * 60 * 60));
        var minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
        if (hours > 0)
            return "".concat(hours, "h ").concat(minutes, "m left");
        if (minutes > 0)
            return "".concat(minutes, "m left");
        return 'Ending soon';
    }
    return 'Ended';
}
function getTeamBadgeUrl(badge) {
    return "".concat(API_BASE, "/api/images/badge/").concat(badge, ".webp");
}
function getPosterUrl(poster) {
    return "".concat(API_BASE).concat(poster, ".webp");
}
var Sports = function () {
    var _a, _b;
    var _c = (0, react_1.useState)(null), sports = _c[0], setSports = _c[1];
    var _d = (0, react_1.useState)(''), selectedSport = _d[0], setSelectedSport = _d[1];
    var _e = (0, react_1.useState)(null), matches = _e[0], setMatches = _e[1];
    var _f = (0, react_1.useState)(true), loading = _f[0], setLoading = _f[1];
    var _g = (0, react_1.useState)(null), error = _g[0], setError = _g[1];
    var _h = (0, react_1.useState)(null), selectedMatch = _h[0], setSelectedMatch = _h[1];
    var _j = (0, react_1.useState)(null), selectedStreams = _j[0], setSelectedStreams = _j[1];
    var _k = (0, react_1.useState)(false), streamsLoading = _k[0], setStreamsLoading = _k[1];
    var _l = (0, react_1.useState)(null), selectedStream = _l[0], setSelectedStream = _l[1];
    var _m = (0, react_1.useState)(''), selectedSource = _m[0], setSelectedSource = _m[1];
    var _o = (0, react_1.useState)(false), iframeLoading = _o[0], setIframeLoading = _o[1];
    var _p = (0, react_1.useState)(null), adGuardConfig = _p[0], setAdGuardConfig = _p[1];
    var intervalRef = (0, react_1.useRef)(null);
    // Suppress benign/3rd-party errors that can block interactions in some environments
    (0, react_1.useEffect)(function () {
        var onError = function (event) {
            try {
                var msg = (event === null || event === void 0 ? void 0 : event.message) || '';
                if (typeof msg === 'string' && (msg.includes('qzqz is not defined') ||
                    msg.includes('ERR_BLOCKED_BY_CLIENT'))) {
                    event.preventDefault();
                    return false;
                }
            }
            catch (_a) { }
            return undefined;
        };
        var onRejection = function (event) {
            try {
                var reason = event === null || event === void 0 ? void 0 : event.reason;
                var msg = typeof reason === 'string' ? reason : ((reason === null || reason === void 0 ? void 0 : reason.message) || '');
                if (typeof msg === 'string' && /interrupted|AbortError/i.test(msg)) {
                    event.preventDefault();
                }
            }
            catch (_a) { }
        };
        window.addEventListener('error', onError);
        window.addEventListener('unhandledrejection', onRejection);
        return function () {
            window.removeEventListener('error', onError);
            window.removeEventListener('unhandledrejection', onRejection);
        };
    }, []);
    // Load AdGuard config
    (0, react_1.useEffect)(function () {
        var config = (0, adGuardAPI_1.getAdGuardConfig)();
        setAdGuardConfig(config);
    }, []);
    // Load sports and set default sport
    (0, react_1.useEffect)(function () {
        var loadSports = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sportsData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSports()];
                    case 1:
                        sportsData = _a.sent();
                        setSports(sportsData);
                        if (sportsData && sportsData.length > 0) {
                            setSelectedSport(sportsData[0].id);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        loadSports();
    }, []);
    var load = (0, react_1.useCallback)(function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (force) {
            var res, err_1;
            if (force === void 0) { force = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedSport)
                            return [2 /*return*/];
                        setError(null);
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchMatchesBySport(selectedSport, force)];
                    case 2:
                        res = _a.sent();
                        if (res === null) {
                            setError('Unable to load matches. The sports service may be temporarily unavailable.');
                        }
                        else {
                            setError(null);
                        }
                        setMatches(res);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Error loading matches:', err_1);
                        setError('Unable to load matches. Please check your connection and try again.');
                        setMatches(null);
                        return [3 /*break*/, 4];
                    case 4:
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }, [selectedSport]);
    (0, react_1.useEffect)(function () {
        load(false);
        if (intervalRef.current)
            window.clearInterval(intervalRef.current);
        intervalRef.current = window.setInterval(function () { return load(false); }, 60000);
        return function () {
            if (intervalRef.current)
                window.clearInterval(intervalRef.current);
        };
    }, [load]);
    var now = Date.now();
    var allMatches = (0, react_1.useMemo)(function () { return matches !== null && matches !== void 0 ? matches : []; }, [matches]);
    var liveMatches = (0, react_1.useMemo)(function () { return allMatches.filter(function (m) { return isLive(now, m); }); }, [allMatches, now]);
    var upcomingMatches = (0, react_1.useMemo)(function () { return allMatches.filter(function (m) { return isUpcoming(now, m); }); }, [allMatches, now]);
    var handleSportChange = function (sportId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (sportId === selectedSport)
                return [2 /*return*/];
            setSelectedSport(sportId);
            return [2 /*return*/];
        });
    }); };
    var handleWatchClick = function (match) { return __awaiter(void 0, void 0, void 0, function () {
        var source, streams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Open in modal (as requested)
                    setSelectedMatch(match);
                    setStreamsLoading(true);
                    setSelectedStreams(null);
                    setSelectedStream(null);
                    setSelectedSource('');
                    if (!(match.sources && match.sources.length > 0)) return [3 /*break*/, 2];
                    source = match.sources[0];
                    setSelectedSource(source.source);
                    return [4 /*yield*/, fetchStreams(source.source, source.id)];
                case 1:
                    streams = _a.sent();
                    setSelectedStreams(streams);
                    if (streams && streams.length > 0) {
                        setSelectedStream(streams[0]);
                        setIframeLoading(true);
                    }
                    _a.label = 2;
                case 2:
                    setStreamsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSourceChange = function (source) { return __awaiter(void 0, void 0, void 0, function () {
        var sourceObj, streams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedMatch)
                        return [2 /*return*/];
                    setStreamsLoading(true);
                    setSelectedSource(source);
                    sourceObj = selectedMatch.sources.find(function (s) { return s.source === source; });
                    if (!sourceObj) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchStreams(sourceObj.source, sourceObj.id)];
                case 1:
                    streams = _a.sent();
                    setSelectedStreams(streams);
                    if (streams && streams.length > 0) {
                        setSelectedStream(streams[0]);
                        setIframeLoading(true);
                    }
                    _a.label = 2;
                case 2:
                    setStreamsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleStreamSelect = function (stream) {
        setSelectedStream(stream);
        setIframeLoading(true);
    };
    var handleIframeLoad = function () { return setIframeLoading(false); };
    var handleCloseModal = function () {
        setSelectedMatch(null);
        setSelectedStreams(null);
        setSelectedStream(null);
        setSelectedSource('');
        setIframeLoading(false);
        setStreamsLoading(false);
    };
    var renderMatchCard = function (match, isLiveMatch, isUpcomingMatch) {
        if (isLiveMatch === void 0) { isLiveMatch = false; }
        if (isUpcomingMatch === void 0) { isUpcomingMatch = false; }
        return (react_1.default.createElement("div", { key: match.id, className: Sports_less_1.default['card'] },
            react_1.default.createElement("div", { className: Sports_less_1.default['poster'] },
                match.poster ? (react_1.default.createElement("img", { className: Sports_less_1.default['poster-img'], src: getPosterUrl(match.poster), alt: match.title, onError: function (e) {
                        var _a;
                        var target = e.currentTarget;
                        target.style.display = 'none';
                        var fallback = (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector('.poster-fallback');
                        if (fallback)
                            fallback.style.display = 'flex';
                    } })) : (react_1.default.createElement("div", { className: Sports_less_1.default['poster-fallback'] })),
                isLiveMatch && react_1.default.createElement("div", { className: Sports_less_1.default['badge-live'] }, "LIVE"),
                isUpcomingMatch && react_1.default.createElement("div", { className: Sports_less_1.default['badge-upcoming'] }, "SOON"),
                react_1.default.createElement("div", { className: Sports_less_1.default['time-remaining'] }, getTimeRemaining(now, match))),
            react_1.default.createElement("div", { className: Sports_less_1.default['card-body'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['card-title'] }, match.title),
                match.teams && (react_1.default.createElement("div", { className: Sports_less_1.default['card-teams'] },
                    match.teams.home && (react_1.default.createElement("div", { className: Sports_less_1.default['team'] },
                        react_1.default.createElement("img", { className: Sports_less_1.default['team-badge'], src: getTeamBadgeUrl(match.teams.home.badge), alt: match.teams.home.name, onError: function (e) {
                                e.currentTarget.style.display = 'none';
                            } }),
                        react_1.default.createElement("span", { className: Sports_less_1.default['team-name'] }, match.teams.home.name))),
                    react_1.default.createElement("span", { className: Sports_less_1.default['vs'] }, "vs"),
                    match.teams.away && (react_1.default.createElement("div", { className: Sports_less_1.default['team'] },
                        react_1.default.createElement("img", { className: Sports_less_1.default['team-badge'], src: getTeamBadgeUrl(match.teams.away.badge), alt: match.teams.away.name, onError: function (e) {
                                e.currentTarget.style.display = 'none';
                            } }),
                        react_1.default.createElement("span", { className: Sports_less_1.default['team-name'] }, match.teams.away.name))))),
                react_1.default.createElement("div", { className: Sports_less_1.default['time'] }, formatTime(match.date)),
                react_1.default.createElement(components_1.Button, { className: Sports_less_1.default['watch-button'], onClick: function () { return handleWatchClick(match); } },
                    react_1.default.createElement("span", { className: Sports_less_1.default['watch-icon'] }, "\u25B6\uFE0F"),
                    isLiveMatch ? 'Watch Live' : 'Watch'))));
    };
    return (react_1.default.createElement(components_1.MainNavBars, { className: Sports_less_1.default['sports-container'], route: 'sports', title: 'SageStreams' },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Sports_less_1.default['sports-content'], 'animation-fade-in') },
            sports && sports.length > 0 && (react_1.default.createElement("div", { className: Sports_less_1.default['sports-navigation'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['sports-tabs'] }, sports.map(function (sport) {
                    var _a;
                    return (react_1.default.createElement(components_1.Button, { key: sport.id, className: (0, classnames_1.default)(Sports_less_1.default['sport-tab'], (_a = {},
                            _a[Sports_less_1.default['sport-tab-active']] = selectedSport === sport.id,
                            _a)), onClick: function () { return handleSportChange(sport.id); } }, sport.name));
                })))),
            loading ? (react_1.default.createElement("div", { className: Sports_less_1.default['message'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['loading-spinner'] }),
                react_1.default.createElement("div", null,
                    "Loading ",
                    ((_a = sports === null || sports === void 0 ? void 0 : sports.find(function (s) { return s.id === selectedSport; })) === null || _a === void 0 ? void 0 : _a.name) || 'sports',
                    " matches\u2026"))) : error ? (react_1.default.createElement("div", { className: Sports_less_1.default['message'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['error-icon'] }, "\u26A0\uFE0F"),
                react_1.default.createElement("div", null, error),
                react_1.default.createElement(components_1.Button, { className: Sports_less_1.default['retry-button'], onClick: function () { return load(true); } }, "\uD83D\uDD04 Try Again"))) : !matches || allMatches.length === 0 ? (react_1.default.createElement("div", { className: Sports_less_1.default['message'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['empty-icon'] }, "\uD83C\uDFDF\uFE0F"),
                react_1.default.createElement("div", null,
                    "No matches available for ",
                    ((_b = sports === null || sports === void 0 ? void 0 : sports.find(function (s) { return s.id === selectedSport; })) === null || _b === void 0 ? void 0 : _b.name) || 'this sport'))) : (react_1.default.createElement(react_1.default.Fragment, null,
                liveMatches.length > 0 && (react_1.default.createElement("section", { className: Sports_less_1.default['section'] },
                    react_1.default.createElement("h2", { className: Sports_less_1.default['section-title'] },
                        react_1.default.createElement("span", { className: Sports_less_1.default['live-dot'] }),
                        "Live Now (",
                        liveMatches.length,
                        ")"),
                    react_1.default.createElement("div", { className: Sports_less_1.default['grid'] }, liveMatches.map(function (match) { return renderMatchCard(match, true); })))),
                upcomingMatches.length > 0 && (react_1.default.createElement("section", { className: Sports_less_1.default['section'] },
                    react_1.default.createElement("h2", { className: Sports_less_1.default['section-title'] },
                        react_1.default.createElement("span", { className: Sports_less_1.default['upcoming-indicator'] }, "\u23F0"),
                        "Upcoming (",
                        upcomingMatches.length,
                        ")"),
                    react_1.default.createElement("div", { className: Sports_less_1.default['grid'] }, upcomingMatches.map(function (match) { return renderMatchCard(match, false, true); })))),
                liveMatches.length === 0 && upcomingMatches.length === 0 && allMatches.length > 0 && (react_1.default.createElement("section", { className: Sports_less_1.default['section'] },
                    react_1.default.createElement("h2", { className: Sports_less_1.default['section-title'] },
                        react_1.default.createElement("span", { className: Sports_less_1.default['ended-indicator'] }, "\uD83C\uDFC1"),
                        "Recent Matches"),
                    react_1.default.createElement("div", { className: Sports_less_1.default['grid'] }, allMatches.slice(0, 12).map(function (match) { return renderMatchCard(match); }))))))),
        react_1.default.createElement(ModalX_1.default, { isOpen: !!selectedMatch, onClose: handleCloseModal, title: selectedMatch === null || selectedMatch === void 0 ? void 0 : selectedMatch.title, subtitle: selectedMatch === null || selectedMatch === void 0 ? void 0 : selectedMatch.category, size: "xl" }, selectedMatch && (react_1.default.createElement("div", null,
            selectedMatch.sources && selectedMatch.sources.length > 0 && (react_1.default.createElement("div", { className: Sports_less_1.default['source-selector'] },
                react_1.default.createElement("h3", null, "Sources"),
                react_1.default.createElement("div", { className: Sports_less_1.default['source-options'] }, selectedMatch.sources.map(function (source) {
                    var _a;
                    return (react_1.default.createElement("button", { key: source.source, className: (0, classnames_1.default)(Sports_less_1.default['source-option'], (_a = {},
                            _a[Sports_less_1.default['source-option-active']] = selectedSource === source.source,
                            _a)), onClick: function () { return handleSourceChange(source.source); } }, source.source.toUpperCase()));
                })))),
            streamsLoading ? (react_1.default.createElement("div", { className: Sports_less_1.default['stream-loading'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['loading-spinner'] }),
                react_1.default.createElement("div", null, "Loading streams\u2026"))) : selectedStreams && selectedStreams.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                selectedStreams.length > 1 && (react_1.default.createElement("div", { className: Sports_less_1.default['stream-selector'] },
                    react_1.default.createElement("h3", null, "Streams"),
                    react_1.default.createElement("div", { className: Sports_less_1.default['stream-options'] }, selectedStreams.map(function (stream) {
                        var _a;
                        return (react_1.default.createElement("button", { key: stream.id, className: (0, classnames_1.default)(Sports_less_1.default['stream-option'], (_a = {},
                                _a[Sports_less_1.default['stream-option-active']] = (selectedStream === null || selectedStream === void 0 ? void 0 : selectedStream.id) === stream.id,
                                _a)), onClick: function () { return handleStreamSelect(stream); } },
                            "S",
                            stream.streamNo,
                            " \u00B7 ",
                            stream.language,
                            " \u00B7 ",
                            stream.hd ? 'HD' : 'SD'));
                    })))),
                react_1.default.createElement("div", { className: Sports_less_1.default['iframe-container'] },
                    iframeLoading && (react_1.default.createElement("div", { className: Sports_less_1.default['iframe-loading'] },
                        react_1.default.createElement("div", { className: Sports_less_1.default['loading-spinner'] }),
                        react_1.default.createElement("div", null, "Loading stream\u2026"))),
                    selectedStream && (react_1.default.createElement("iframe", { className: Sports_less_1.default['iframe'], src: selectedStream.embedUrl, title: selectedMatch.title, allow: "autoplay; fullscreen; picture-in-picture; encrypted-media", allowFullScreen: true, onLoad: handleIframeLoad, style: { opacity: iframeLoading ? 0 : 1 } }))),
                react_1.default.createElement("div", { className: Sports_less_1.default['stream-info'] },
                    react_1.default.createElement("div", { className: Sports_less_1.default['stream-meta'] },
                        selectedMatch.category && (react_1.default.createElement("div", { className: Sports_less_1.default['stream-category'] },
                            react_1.default.createElement("span", { className: Sports_less_1.default['category-icon'] }, "\uD83C\uDFF7\uFE0F"),
                            react_1.default.createElement("span", null, selectedMatch.category))),
                        react_1.default.createElement("div", { className: Sports_less_1.default['stream-time'] },
                            react_1.default.createElement("span", { className: Sports_less_1.default['time-icon'] }, "\uD83D\uDD50"),
                            react_1.default.createElement("span", null, formatTime(selectedMatch.date))))))) : (react_1.default.createElement("div", { className: Sports_less_1.default['no-stream-message'] },
                react_1.default.createElement("div", { className: Sports_less_1.default['no-stream-icon'] }, "\u23F3"),
                react_1.default.createElement("h3", null, "No streams available"),
                react_1.default.createElement("p", null, "Please try another source or come back later."))))))));
};
exports.default = Sports;
